import dayjs from 'dayjs';
import findClosestAvailableDate from './findClosestAvailableDate';

const RETURN_OFFSET_DAYS = 3;

const isEmpty = value => Object.keys(value).length === 0;

const clampDate = (date, maxDate) => {
  const day = dayjs(date).startOf('day');
  const maxDay = dayjs(maxDate).startOf('day');
  return day.isAfter(maxDay, 'day') ? maxDay.toDate() : day.toDate();
};

const fallbackReturnDate = (target, departure, maxDate) => {
  const fallback = clampDate(target, maxDate);
  return dayjs(fallback).isAfter(dayjs(departure).startOf('day'), 'day')
    ? fallback
    : null;
};

const pickRoundTripDates = ({
  departureAvailability,
  returnAvailability,
  today,
  maxDate,
  fetched,
}) => {
  if (!fetched.dep) {
    return { departure: null, return: null };
  }

  const departure = isEmpty(departureAvailability)
    ? dayjs(today).startOf('day').toDate()
    : findClosestAvailableDate(departureAvailability, today, {
      direction: 'forward',
      maxDate,
    });

  if (!departure || !fetched.ret) {
    return { departure, return: null };
  }

  const returnTarget = dayjs(departure).add(RETURN_OFFSET_DAYS, 'day').toDate();
  const pickedReturn = isEmpty(returnAvailability)
    ? fallbackReturnDate(returnTarget, departure, maxDate)
    : findClosestAvailableDate(returnAvailability, returnTarget, {
      direction: 'bidirectional',
      lowerBound: departure,
      maxDate,
    });

  return { departure, return: pickedReturn };
};

export default pickRoundTripDates;
